module.exports = __webpack_public_path__ + "img/detail-transport.798858f1.svg";